import { render, staticRenderFns } from "./MeetingRulesList.vue?vue&type=template&id=22461f18&scoped=true&"
import script from "./MeetingRulesList.vue?vue&type=script&lang=ts&"
export * from "./MeetingRulesList.vue?vue&type=script&lang=ts&"
import style0 from "./MeetingRulesList.vue?vue&type=style&index=0&id=22461f18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22461f18",
  null
  
)

export default component.exports